import { render, staticRenderFns } from "./page2part9.vue?vue&type=template&id=685598a2&scoped=true"
var script = {}
import style0 from "./page2part9.vue?vue&type=style&index=0&id=685598a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685598a2",
  null
  
)

export default component.exports